<template>
	<div class="table-body-wrapper" :style="'--total-cols:'+totalCols*colMultiplier">
		<div
			v-if="items && items.length"
			v-for="row in items"
			class="table-row-body"
			@click="this.$emit('click-row', row)"
		>
			<div
				v-for="field in fields"
				:style="'--cols:'+field.cols*colMultiplier"
				class="table-col-body" :class="{noPadding: field.noPadding}"
			>
				<slot :name="field.slotName" :item="row">
					<p>{{formatFieldValue(row[field.fieldName], field.fieldName, field.hasOwnProperty('formatter') ? field.formatter : null, field.suffix)}}</p>
				</slot>
			</div>
		</div>
		<div v-else class="table-row-body no-content">
			<p>{{ getString('no_result') }}</p>
		</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, currencyStore}
	},
	emits: ['click-row'],
	name: "AppTableBody",
	data() {
		return {
			statusValues: ['paid', 'pending', 'in_transit', 'canceled', 'succeeded', 'refunded', 'partially_refunded', 'failed', 'available'],
			statusTranslations: [this.getString('completed'), this.getString('pending'), this.getString('in_transit'), this.getString('canceled'), this.getString('succeeded'), this.getString('refunded'), this.getString('partially_refunded'), this.getString('failed'), this.getString('available')],
		}
	},
	components: {},
	props: {
		items: {
			type: Array,
			default: [],
		},
		fields: {
			type: Array,
			required: true,
			validator(value) {
				return value.every(item => item.fieldName && item.cols);
			}
		},
		colMultiplier: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		totalCols() {
			let total = 0;
			this.fields.forEach(item => total += item.cols || 1);
			return total;
		},
	},
	methods: {
		formatFieldValue(value, fieldName, formatter, suffix) {
			//TODO don't use field name, use only formatter (refactor)
			let formattedValue;
			if(typeof formatter === 'function') {
				formattedValue = formatter(value);
			} else if (fieldName === 'date' || formatter === 'date') {
				formattedValue = value && value.toLocaleString ? value.toLocaleString('it', {year: '2-digit', month: '2-digit', day: 'numeric',hour: '2-digit', minute:'2-digit', hour12: false}) : null;
			} else if (fieldName === 'amount' || formatter === 'currency') {
				formattedValue = this.currencyStore.readableCurrencyValue(value);
			} else if (fieldName === 'status' && this.statusValues.includes(value)) {
				formattedValue = this.statusTranslations[this.statusValues.indexOf(value)];
			} else {
				formattedValue = value;
			}

			if (suffix && formattedValue != null) {
				return formattedValue + suffix;
			}
			return formattedValue;
		}
	}
}
</script>

<style lang="scss" scoped>
:root {
	--cols: 1;
	--l-cols: calc(var(--cols) * 1.5);
	--m-cols: calc(var(--cols) * 2);
	--s-cols: calc(var(--cols) * 3);
	--xs-cols: calc(var(--cols) * 6);
	--total-cols: 12;
	--l-total-cols: calc(var(--total-cols) * 1.5);
	--m-total-cols: calc(var(--total-cols) * 2);
	--s-total-cols: calc(var(--total-cols) * 3);
	--xs-total-cols: calc(var(--total-cols) * 6);
}
.table-body-wrapper {
	background-color: var(--color-bg);
	position: relative;
	&:before, &:after{
		content: "";
		position: absolute;
		height: 100%;
		width: 1px;
		top: 0px;
		left: 0;
		background-color: $alpha_2;
	}
	&:after{
		left: calc(100% / 12 * var(--total-cols) - 1px);
	}
	.table-row-body {
		display: flex;
		align-items: stretch;
		position: relative;

		&:after{
			content: "";
			position: absolute;
			bottom: 0;
			left: 1px;
			width: calc(100% / 12 * var(--total-cols) - 2px);
			height: 1px;
			background-color: $alpha_2;
		}
		
		&.no-content {
			padding: 10px;
			
			p {
				width: 100%;
				text-align: center;
			}
		}
	}
	.table-col-body {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: calc(100% / 12 * var(--cols));
		max-width: calc(100% / 12 * var(--cols));
		min-width: calc(100% / 12 * var(--cols));
		min-height: 20px;
		position: relative;
		padding: 5px;
		background-color: var(--color-bg);

		&.noPadding {
			padding: 0;
		}

		&:not(:last-of-type) {
			&:after{
				content: "";
				position: absolute;
				top: 0;
				right: 0;
				width: 1px;
				height: calc(100% - 1px);
				background-color: $alpha_2;
			}
		}

		p {
			max-width: 100%;
			overflow-wrap: break-word;
			hyphens: auto;
			font-size: 12px;
			line-height: 16px;
			@include textSelect();
		}
	}
	:nth-child(even).table-row-body {
		.table-col-body {
			background-color: var(--color-alpha-1);
		}
	}
}
</style>